import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faList, faGlobe } from "@fortawesome/free-solid-svg-icons";

const PrivateMainPage = () => {
  return (
    <div
      style={{
        backgroundImage: "url('/imagenes/background-home.jpg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "80vh", // Altura exacta de la pantalla
        overflow: "hidden", // Elimina scroll
        position: "relative",
        color: "white",
        
      }}
    >
      {/* Overlay oscuro para mejor contraste */}
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      ></div>

      {/* Contenido principal */}
      <div
        className="container d-flex flex-column align-items-center justify-content-center text-center"
        style={{
          height: "90vh", // Ocupa toda la pantalla
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Imagen centrada arriba del título */}
        <img
          src="/imagenes/LOGO3.png"
          alt="Logo"
          style={{
            width: "150px",
            marginBottom: "2rem",
          }}
        />

        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            fontFamily: "'Libre Baskerville', serif",
            marginBottom: "2rem",
          }}
        >
          VIGILANCIA EPIDEMIOLOGICA DE CONTACTOS
        </h1>

 


      
 <div id="accesos" className="row mt-5 g-4 justify-content-center">
          {/* Botones con estilo personalizado */}
          <div className="col-md-4 d-flex justify-content-center">
            <Link
              to="GIS"
              className="text-decoration-none"
              style={{
                backgroundColor: "#375a7f",
                color: "white",
                padding: "0.75rem 2rem",
                borderRadius: "30px",
                fontWeight: "600",
                boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                display: "flex",
                 alignItems: "center",
                gap: "4px",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2e4563")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#375a7f")}
            >
              <FontAwesomeIcon icon={faGlobe} size="lg" />
              G.I.S.
            </Link>
          </div>

          <div className="col-md-4 d-flex justify-content-center">
            <Link
              to="ListadoCasosContactos"
              className="text-decoration-none"
              style={{
                backgroundColor: "#375a7f",
                color: "white",
                padding: "0.75rem 2rem",
                borderRadius: "30px",
                fontWeight: "600",
                boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2e4563")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#375a7f")}
            >
              <FontAwesomeIcon icon={faList} size="lg" />
              Listados
            </Link>
          </div>

          <div className="col-md-4 d-flex justify-content-center">
            <Link
              to="addPersona"
              className="text-decoration-none"
              style={{
                backgroundColor: "#375a7f",
                color: "white",
                padding: "0.75rem 2rem",
                borderRadius: "30px",
                fontWeight: "600",
                boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2e4563")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#375a7f")}
            >
              <FontAwesomeIcon icon={faDatabase} size="lg" />
              Carga de Datos
            </Link>
          </div></div>

        </div>
      </div>
   
  );
};

export default PrivateMainPage;



   